/**
 * SupportChat — Bouton flottant support BizCoach + widget Zoho SalesIQ
 * Charge le script SalesIQ dynamiquement et offre un bouton custom
 * qui ouvre/ferme le chat support.
 */

import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

const SALESIQ_WIDGET_URL = "https://salesiq.zohopublic.com/widget?wc=siqed6b046f07b0394f60a088700854472de8678c878bc15e791c174dfedbb86743";

export function SupportChat() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Masquer le lanceur natif SalesIQ par CSS (plus fiable que l'API)
    if (!document.getElementById("zsiq-hide-launcher")) {
      const style = document.createElement("style");
      style.id = "zsiq-hide-launcher";
      style.textContent = ".zsiq_floatmain, #zsiq_float, .zsiq_theme1 .zsiq_flt_rel { display: none !important; }";
      document.head.appendChild(style);
    }

    // Ne pas charger en double
    if (document.getElementById("zsiqscript")) return;

    // Init SalesIQ
    (window as any).$zoho = (window as any).$zoho || {};
    (window as any).$zoho.salesiq = (window as any).$zoho.salesiq || {
      ready: function () {},
    };

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "zsiqscript";
    script.defer = true;
    script.src = SALESIQ_WIDGET_URL;
    document.head.appendChild(script);
  }, []);

  const toggleChat = () => {
    const salesiq = (window as any).$zoho?.salesiq;
    if (salesiq) {
      if (isOpen) {
        salesiq.floatwindow.close();
      } else {
        salesiq.floatwindow.open();
      }
      setIsOpen(!isOpen);
    }
  };

  return (
    <button
      onClick={toggleChat}
      className="fixed bottom-5 right-5 z-40 hidden md:flex items-center justify-center w-12 h-12 rounded-full shadow-lg transition-all hover:scale-105 active:scale-95"
      style={{ backgroundColor: isOpen ? "#C0423F" : "#384872" }}
      title={isOpen ? "Fermer le support" : "Besoin d'aide ?"}
      aria-label={isOpen ? "Fermer le support" : "Ouvrir le support"}
    >
      {isOpen ? (
        <X className="h-5 w-5 text-white" />
      ) : (
        <MessageCircle className="h-5 w-5 text-white" />
      )}
    </button>
  );
}
